import React, { useMemo, useState, useEffect } from "react";
import PropTypes from 'prop-types';
import { useTable } from 'react-table';
import { Link, useNavigate } from "react-router-dom"
//import components
import Breadcrumbs from '../../components/Common/Breadcrumb';
import TableContainer from '../../components/Common/TableContainer';
import DeleteConfirmationModal from "./DeleteConfirmationModal"
import axios from 'axios';
import AddEditModal from "./AddEditModal";
import { getroles } from "service/myapi";

function DatatableTables() {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
  const [selectedDeleteData, setSelectedDeleteData] = useState(null)
  const [allroles, setallroles] = useState();
  const [selectedItem, setSelectedItem] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [message, setMessage] = useState('');
  const navigate = useNavigate()

  const openAddModal = () => {
    setSelectedItem({ mode: "add" });
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };
  const openDeleteModal = rowData => {
    setSelectedDeleteData(rowData)
    setIsDeleteModalOpen(true)
  }

  const closeDeleteModal = () => {
    setSelectedDeleteData(null)
    setIsDeleteModalOpen(false)
  }
  const handleDelete = async () => {
    try {
      if (selectedDeleteData) {
        const req = await axios.delete(
          `${process.env.REACT_APP_MYAPI_URL}/deleterole/${selectedDeleteData}`
        )
        const res = await req.data

        if (res) {
          closeDeleteModal();
          getallroles();
        }
      }
    } catch (error) {
      console.error(error)
    }
  }
  useEffect(() => {
    getallroles();
  }, []);

  const handleUpdate = async (roles) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_MYAPI_URL}/addrole`,
        {
          role: roles
        }
      );

      if (response.status === 200) {
        getallroles();
        closeModal();
      } else {
        setMessage(response.data.message);
      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        setMessage(error.response.data.message);
        setTimeout(() => {
          setMessage('');
        }, 2000);
      } else {
        console.error("Error updating data:", error.message);
      }
    }
  };



  const getallroles = async () => {
    let response = await getroles();
    if (response.error) {
      console.log('Error while fetching roles:', response.error);
    } else {
      setallroles(response.data);
      //console.log(response.data);
    }
  }
  const handleClick = selectedrole => {
    console.log("Button clicked with id:", selectedrole)
    navigate(`/manage_permission`, { state: selectedrole })
  }
  const columns = useMemo(
    () => [
      {
        Header: "#",
        Cell: ({ row, rows }) => {
          return <span>{rows.findIndex(r => r.id === row.id) + 1}</span>;
        },
      },
      {
        Header: 'Role',
        accessor: 'role',
      },
      {
        Header: "Action",
        accessor: row => {
          const packging = row?.role
          const id = row?._id
          return (
            <>
              <button
                onClick={() => handleClick(packging)}
                className="btn btn-primary">
                Permission
              </button>
              <button className="btn btn-danger mx-2"
                onClick={() => openDeleteModal(id)}
              > <i className="mdi mdi-trash-can font-size-15"></i> </button>
            </>
          )
        },
      },
    ],
    []
  );

  const data = [

  ];

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h1 className="page-title"></h1>
          <button
            className="btn btn-primary"
            style={{ textTransform: 'uppercase' }}
            onClick={() => openAddModal()}
          >
            ADD NEW ROLE
          </button>
        </div>
        <Breadcrumbs title="Setting" breadcrumbItem="Roles" />
        {allroles && (
          <TableContainer
            columns={columns}
            data={allroles.roles}
            isGlobalFilter={true}
            isAddOptions={false}
            customPageSize={10}
            className="custom-header-css"
          />
        )}
        {isModalOpen && (
          <AddEditModal
            isOpen={isModalOpen}
            onClose={closeModal}
            onSave={handleUpdate}
            message={message}
          />
        )}
        <DeleteConfirmationModal
          isOpen={isDeleteModalOpen}
          onClose={closeDeleteModal}
          onConfirm={handleDelete}
        />
      </div>
    </div>
  );

}
DatatableTables.propTypes = {
  preGlobalFilteredRows: PropTypes.any,

};

export default DatatableTables;